import React from "react";

import "./CompanyTree.scss";
import { TreeView } from "@material-ui/lab";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import TreeItem from "@material-ui/lab/TreeItem";
import getStyles from "./getStyles";
import AccountCircle from "@material-ui/icons/AccountCircle";
import AccountBalance from "@material-ui/icons/AccountBalance";
import StoreMallDirectory from "@material-ui/icons/StoreMallDirectory";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { Typography } from "@material-ui/core";

const CompanyTree = (props: any) => {
  const classes = getStyles();

  return (
    <TreeView
      className={classes.root}
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      multiSelect
      expanded={props.expanded}
    >
      <TreeItem
        className="TreeView-root"
        nodeId={"/"}
        label={
          <div className={classes.labelRoot}>
            <MoreHorizIcon color="inherit" className={classes.labelIcon} />
            <Typography variant="body2" className={classes.labelText}>
              Companies
            </Typography>
            <Typography variant="caption" color="inherit">
              {props.data &&
                props.data.companies &&
                props.data.companies.length}
            </Typography>
          </div>
        }
        onClick={() => {
          props.openCloseNode("/");
          props.selectCompany("");
          props.setItemAction([{ action: "Add", type: "Company" }]);
          props.setShowAllCompanies(true);
          props.setShowCompanyDetails(false);
          props.setShowBranchDetails(false);
          props.setShowUserDetails(false);
        }}
      >
        <div>
          {props.data &&
            props.data.companies &&
            props.data.companies.map((company: any) => {
              return (
                <TreeItem
                  className="TreeView-companyNode"
                  key={`CompanyTree-company-${company.id}`}
                  nodeId={"/" + company.id}
                  label={
                    <div className={classes.labelRoot}>
                      <AccountBalance
                        color="inherit"
                        className={classes.labelIcon}
                      />
                      <Typography variant="body2" className={classes.labelText}>
                        {`${
                          company.branches && company.branches.length > 20
                            ? `* ${company.name}`
                            : company.name
                        }`}
                      </Typography>
                    </div>
                  }
                  onClick={() => {
                    props.selectCompany(company.id);
                    props.setLimitedBranchesMessage(
                      company.branches && company.branches.length > 20
                    );
                  }}
                >
                  {company.branches &&
                    company.branches.map((branch: any) => {
                      return (
                        <TreeItem
                          className="TreeView-branchNode"
                          key={`CompanyTree-branch-${company.id}-${branch.id}`}
                          nodeId={"/" + company.id + "/" + branch.id}
                          label={
                            <div className={classes.labelRoot}>
                              <StoreMallDirectory
                                color="inherit"
                                className={classes.labelIcon}
                              />
                              <Typography
                                variant="body2"
                                className={classes.labelText}
                              >
                                {`${
                                  branch.customers.length > 20
                                    ? `* ${branch.name}`
                                    : branch.name
                                }`}
                              </Typography>
                            </div>
                          }
                          onClick={() => {
                            props.selectBranch(company.id, branch.id);
                            props.setLimitedUsersMessage(
                              branch.customers && branch.customers.length > 20
                            );
                          }}
                        >
                          {branch.customers &&
                            branch.customers.map((customer: any) => {
                              return (
                                <TreeItem
                                  className="TreeView-userNode"
                                  onClick={() => {
                                    props.selectUser(company.id, customer.id);
                                  }}
                                  key={`CompanyTree-user-${company.id}-${branch.id}-${customer.id}`}
                                  nodeId={
                                    "/" +
                                    company.id +
                                    "/" +
                                    branch.id +
                                    "/" +
                                    customer.id
                                  }
                                  label={
                                    <div className={classes.labelRoot}>
                                      <AccountCircle
                                        color="inherit"
                                        className={classes.labelIcon}
                                      />
                                      <Typography
                                        variant="body2"
                                        className={classes.labelText}
                                      >
                                        {`${customer.firstName ||
                                          ""} ${customer.lastName ||
                                          ""}`.trim()}
                                      </Typography>
                                    </div>
                                  }
                                />
                              );
                            })}
                        </TreeItem>
                      );
                    })}
                </TreeItem>
              );
            })}
        </div>
      </TreeItem>
    </TreeView>
  );
};

export default CompanyTree;
